import ImageSearch from "@mui/icons-material/ImageSearch";
import { Box, Button, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import { toast } from "react-hot-toast";
import { assetLinkUrl } from "../../utils/asset-link-url";

import type { Asset } from "./server/digital-asset-service";
import type { FC } from "react";

export const LinkToAssetButton: FC<{ asset: Asset }> = ({ asset }) => {
  const assetLink = useMemo(() => assetLinkUrl(asset.id), [asset.id]);

  const handleClick = useCallback(() => {
    if (!assetLink) return;

    void navigator.clipboard.writeText(assetLink);
    toast.success("Link copied to clipboard");
  }, [assetLink]);

  return (
    assetLink && (
      <Box>
        <Button
          data-analytics-id="content-library-link-to-preview"
          onClick={handleClick}
          startIcon={<ImageSearch />}
          variant="text"
          size="small"
          sx={{
            p: 0,
            m: 0,
            "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
          }}
        >
          <Typography variant="caption" color="primary">
            Copy link to in-app preview
          </Typography>
        </Button>
      </Box>
    )
  );
};
